import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { ContactRequest } from 'api/common/requests'
import { ContactResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'

/**
 * お問い合わせAPI
 * @param request
 * @param callback
 */
const contactAPI = async (request: ContactRequest, callback: (result: boolean) => void) => {
  await apiClient.post('/contact', request).then((response: AxiosResponse<ContactResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const apiResult = response?.data?.result ?? false
    callback(status === Status.Success && apiResult)
  })
}

export default contactAPI
